import styled from 'styled-components'
import logo from '../imgs/logo.png'
import { useDispatch } from 'react-redux'
import LogoutOutlinedIcon from '@mui/icons-material/LogoutOutlined';
import { user,userLogin } from '../redux/actions/loginActions.js'
import { useNavigate } from 'react-router-dom';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import { logoutUser } from '../services/login.js'


const Container=styled.div`
	background-color:#F9F9F9;
	display:flex;
	justify-content:space-between;
	align-items:center
 `;

const Logo=styled.img`
	height:7vh;
	margin:9px;
	min-height:40px;
	filter: drop-shadow(0 1px 1px rgba(0, 0, 0, 0.9));
	
`;

const ContainerLogo=styled.div`	
	display:flex;	
	align-items:center;
		
 `;

const ContainerLogout=styled.div`
  display:flex;
  align-items:center;  
  &:hover{
    cursor:pointer
  }
`;

const ContainerRight=styled.div`
	display:flex;
	flex-direction:row-reverse
`;



 export default function NavBar(props){
 	let {navigation}=props;
 	let dispatch=useDispatch();
 	let navigate=useNavigate();


 	const lightTheme=createTheme({

 	palette: {
   		 mode: 'light',
    	primary: {
      		main: '#27B0FE',
      		contrastText: '#ffebee',
    	}
  },
    typography: {
      fontFamily: ['Poppins', 'sans-serif'].join(","),
      fontSize: 10,

    }

 })

 	let handleLogout=()=>{
 				try{
 					logoutUser();
 					dispatch(userLogin(false));
 					dispatch(user(""));
          navigate("/");
 				}catch(err){console.log(err)}
 					
          
   };
 	return(
 		<Container>
 		<ThemeProvider theme={lightTheme}>
 			<ContainerLogo>
		 		<Logo src={logo}/> <b>Playlan </b>  mym™
		 	</ContainerLogo>
		 	<ContainerRight>
		 		<ContainerLogout onClick={handleLogout} >         			
					<LogoutOutlinedIcon style={{margin:"15px"}}/>
        		</ContainerLogout>
 				{navigation}
 			</ContainerRight>
 			</ThemeProvider >
 		</Container>
 		)
 }